import React from 'react';
import { FaFile, FaFilePdf } from 'react-icons/fa';
import {
  u3121StripProjetNumberPrefix,
  type U3121FlatDocumentItem,
} from '../../../../tools/u3121FlattenDocumentTree';

export interface U3121ProjectDocumentFlatListProps {
  items: U3121FlatDocumentItem[];
  selectedPath: string | null;
  /** N° projet pour retirer le préfixe du chemin affiché. */
  projetNumber?: string | null;
  onSelectFile: (item: U3121FlatDocumentItem) => void;
}

const U3121ProjectDocumentFlatList: React.FC<U3121ProjectDocumentFlatListProps> = ({
  items,
  selectedPath,
  projetNumber,
  onSelectFile,
}) => {
  return (
    <div className="overflow-auto text-sm" role="list">
      {items.map((item) => {
        const isSelected = selectedPath === item.relativePath;
        const FileIcon = item.previewable ? FaFilePdf : FaFile;
        const location = u3121StripProjetNumberPrefix(item.relativePath, projetNumber);
        return (
          <button
            key={item.documentId}
            type="button"
            role="listitem"
            className={`grid w-full grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] items-center gap-3 rounded px-2 py-1.5 text-left hover:bg-gray-100 ${
              isSelected ? 'bg-blue-50 text-blue-800' : 'text-gray-800'
            }`}
            onClick={() => onSelectFile(item)}
          >
            <span className="flex min-w-0 items-center gap-2">
              <span className="inline-flex shrink-0">
                <FileIcon
                  size={14}
                  className={item.previewable ? 'text-red-600' : 'text-gray-500'}
                />
              </span>
              <span className="truncate font-medium">{item.name}</span>
            </span>
            <span className="min-w-0 truncate text-xs font-normal text-gray-500" title={location}>
              {location}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default U3121ProjectDocumentFlatList;
